const DEFAULT_EXPIRE_TIME = 172800;

class ExpiringLocalStorage {
  static set(key, value, ttl = null) {
    if (!ttl) {
      ttl = DEFAULT_EXPIRE_TIME;
    }
    localStorage.setItem(
      key,
      JSON.stringify({
        value: value,
        expire: new Date().getTime() + parseInt(ttl, 10) * 1000,
      }),
    );
  }

  static get(key) {
    const item = this.getWithExpiry(key);
    if (!item) {
      return null;
    }
    return item.value;
  }

  static getWithExpiry(key) {
    let item = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!item) {
      return null;
    }

    item = JSON.parse(item);

    const timestamp = new Date().getTime();

    if (timestamp > item.expire) {
      this.remove(key);
      return null;
    }
    item.ttl = (item.expire - timestamp) / 1000;

    return item;
  }

  static remove(key) {
    localStorage.removeItem(key);
  }
}

export default ExpiringLocalStorage;
